// extracted by mini-css-extract-plugin
export default {"indicator":"IndicatorDot_indicator__mtLl1","green":"IndicatorDot_green__YjdlH","blue":"IndicatorDot_blue__dMbM3"};